<template>
	<div class="pa-6">
		<v-card>
			<v-card-title>
				P&L Бюджеты
				<v-spacer></v-spacer>

				<v-btn icon class="mr-2" @click="newEntry">
					<v-icon>add_circle</v-icon>
				</v-btn>
			</v-card-title>

			<v-data-table
				:headers="headers"
				:items="data"
				:items-per-page="-1"
				:loading="loadingMore"
				hide-default-footer
				disable-sort
				:no-data-text="loadingMore ? 'Загрузка...' : 'Ничего не нашлось'"
				item-key="id">
				<template v-slot:item="props">
					<tr @click="$router.push(props.item.id)" :style="{ cursor: 'pointer'}">
						<td class="text-center">{{ props.item.hotelCode }}</td>
						<td class="text-center">{{ props.item.period }}</td>
						<td class="text-center nowrap">{{ textStatus(props.item.status) }}</td>
					</tr>
				</template>
			</v-data-table>
			<v-container v-if="!loadedAll && data.length > 1">
				<v-row justify="center">
					<v-col cols="1">
						<v-progress-circular
							indeterminate
							color="primary"
						></v-progress-circular>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
		<v-dialog v-model="dialog.show" max-width="800" persistent>
			<v-card>
				<v-card-title class="subtitle-1">Создание нового бюджета</v-card-title>
				<v-form ref="f" v-model="dialog.valid">
		          	<v-card-text>
		            	<v-container>
		              		<v-row >
		                		<v-col cols="12">
		                  			<v-select v-model="dialog.hotelCode"
											  :items="hotels"
											  item-value="code"
											  item-text="name"
											  label="Отель">
									</v-select>
		                		</v-col>
								<v-col cols="6">
									<v-subheader>Первый месяц</v-subheader>
									<v-date-picker 	v-model="dialog.mon_start"
													type="month"
													landscape
													required
													reactive
													locale="ru-ru"
													:show-current="false"
													:max="dialog.mon_end"
													full-width>
									</v-date-picker>
		                		</v-col>
								<v-col cols="6">
									<v-subheader>Последний месяц</v-subheader>
									<v-date-picker 	v-model="dialog.mon_end"
													type="month"
													landscape
													required
													reactive
													locale="ru-ru"
													:show-current="false"
													:min="dialog.mon_start"
													full-width>
									</v-date-picker>
		                		</v-col>
		              		</v-row>
		            	</v-container>
		          	</v-card-text>
				</v-form>

		        <v-card-actions>
					<v-btn text
						   @click="add"
						   :disabled="!dialog.valid">
						Добавить
					</v-btn>
		            <v-btn text @click="close">Отмена</v-btn>
		        </v-card-actions>
        	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
</style>

<script>
	import {c} from '../../../lib/const'
	import {api} from '../../../lib/api'
	import {display} from '../../../lib/display'
	import {getMonthName} from '../../../js/common.js'
	import _ from 'lodash'

	export default {
		data: () => ({
			loadingMore: false,
			loadedAll: false,
			data: [],
			search: '',
			headers: [
				{
					text: 'Код отеля',
					value: 'hotelCode',
					align: 'center',
				},
				{
					text: 'Период',
					value: 'period',
					align: 'center',
				},
				{
					text: 'Статус',
					value: 'mon',
					align: 'center',
				},
			],
			dialog: {
				show: false,
				valid: false,
				hotelCode: '',
				mon_start: '',
				mon_end: '',
			},
		}),
		computed: {
			hotels() {
				return this.$store.getters.availableHotels
			}
		},
		created() {
			this.loadMore()
			this.debouncedLoadMore = _.debounce(this.loadMore, 1000)
		},
		mounted() {
			window.onscroll = this.scrollTrigger
		},
		methods: {
			newEntry() {
				this.dialog.show = true
				this.dialog.hotelCode = this.hotels[0].code
			},
			add() {
				let hotelCode = this.dialog.hotelCode

				api.post('pl/budget/add_entry', {
					hotelCode: this.dialog.hotelCode,
					mon_start: this.dialog.mon_start,
					mon_end: this.dialog.mon_end,
				})
				.then(response => {
					this.data = []
					this.loadedAll = false
					this.loadingMore = false
					this.loadMore()
					this.dialog.show = false
				}, error => {})
			},
			close() {
				this.dialog.show = false
			},
			scrollTrigger() {
				let scrolled = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 250

				if (scrolled) this.debouncedLoadMore()
			},
			textStatus(status) {
				if (!status) return 'Согласование FC'
				if (status == c.PL_STATUS_INITIAL) return 'Согласование FC'
				if (status == c.PL_STATUS_FC_REPORTED) return 'Согласование GM'
				if (status == c.PL_STATUS_GM_APPROVED) return 'Согласование УК'
				if (status == c.PL_STATUS_HO_APPROVED) return 'Согласование владельцем'
				if (status == c.PL_STATUS_FINAL) return 'Финальная'
				if (status == c.PL_STATUS_OUTDATED) return 'Версия устарела'
			},
			loadMore () {
				if (!this.loadedAll && !this.loadingMore) {
					// console.log('loadMore')
					this.loadingMore = true

					api.post('pl/budget/get_list', {
						offset: this.data.length,
					})
					.then(response => {
						response.data.list.forEach(r => {
							this.data.push(r)
						})

						this.loadedAll = response.data.all
						this.loadingMore = false
						this.scrollTrigger()
					}, error => {})
				}
			},
		}
	}
</script>
